import DictionaryIcon_Trans from "../../../assets/UI/DictionaryIcon_Trans.png";
import SearchBarDictionary from "../DictionaryComponents/SearchBar_Dictionary/SearchBar_Dictionary";
import "../Dictionary.css";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";

//Word Grids
import WordGridLarge from "../DictionaryComponents/WordGrid/WordGridLarge";

//Arrays
import { BasicEmotions } from "../../../SubjectData/BasicWords/Emotions";
import { PositiveEmotions } from "../../../SubjectData/BasicWords/Emotions";
import { NegativeEmotions } from "../../../SubjectData/BasicWords/Emotions";
import { ComplexEmotions } from "../../../SubjectData/BasicWords/Emotions";

import Popup from "../../../Components/Popup/Dictionary_Popup";
import {useState} from "react";

export default function EmotionsDictionary(){

    const [openPopup, setOpenPopup] = useState(null);

    const allData = [
                        ...BasicEmotions, 
                        ...PositiveEmotions,
                        ...NegativeEmotions,
                        ...ComplexEmotions,
                    
                    ];
    
        return(
       
               <div>
                   <HeaderNavNTM GoBack_to="/EmotionsNav"/>
                   <div className="blue-header-dict">
                       
                       <img className="DictionaryImage" src={DictionaryIcon_Trans} alt="Dictionary"></img>
                      
                         <SearchBarDictionary data={allData} onSelectItem={setOpenPopup} />
                       
                   </div>
       
                   <div>
                       
                       <WordGridLarge data={BasicEmotions} title="Basic Emotions" onSelectItem={setOpenPopup} />
                       <WordGridLarge data={PositiveEmotions} title="Postive Emotions" onSelectItem={setOpenPopup} />  
                       <WordGridLarge data={NegativeEmotions} title="Negative Emotions" onSelectItem={setOpenPopup} />
                       <WordGridLarge data={ComplexEmotions} title="Complex Emotions" onSelectItem={setOpenPopup} />  
                                              
                       <Popup item={openPopup} onClose={() => setOpenPopup(null)} />
                  
                   </div>
                   
               </div>
       
           );
       
       }
       
    
    
    //Resources
        //Making a search bar
            //https://builtin.com/articles/react-search-bar